import DatasetCard from './DatasetCard.js';
// import StateConsumptionFY23 from './StateConsumptionFY23.js';
import PetroleumImports from './PetroleumImports.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './DatasetCardGrid.css';

function DatasetCardGrid(props) {
    const { metadata, activeDomain } = props;
    const chartMetadata = metadata.filter((metaObj) => metaObj['datawrapperLink'] !== undefined);

    // const tableauByAgencyURL = "https://public.tableau.com/views/state_facilities_fy23_v2/ByAgencyDash?:language=en-US&:display_count=n&:origin=viz_share_link&:showVizHome=no&:toolbar=no&:device=default"
    // const tableauByMonthURL = "https://public.tableau.com/views/state_facilities_fy23_v2_by_month/ByMonthDash?:language=en-US&publish=yes&:display_count=n&:origin=viz_share_link"
    // const tableauByMonthLegendURL ="https://public.tableau.com/views/state_facilities_fy23_v2_by_month_legend/ByMonthDashLegend?:language=en-US&publish=yes&:display_count=n&:origin=viz_share_link"

    const tableauPetroleumImportsProps = {
        thumbnailURL: "/thumbnails/petroleum_imports_sm.png",
        modalThumbnailURL: "/thumbnails/petroleum_imports_lg.png",
        tableauURL: "https://public.tableau.com/app/profile/warren.marshall7938/viz/HawaiiFuelImportsDashboard/Dashboard1",
        domain: "non_renewable_energy",
        description: "",
    };
    
// tableauURL: "https://public.tableau.com/views/petroleum_imports/PetroleumImports?:language=en-US&:display_count=n&:origin=viz_share_link&:showVizHome=no&:toolbar=no&:device=default"
    return (
        <Row xs={1} sm={1} md={1} lg={2} xl={2} xxl={3}
            style={{
                background: '#E5E5E5', paddingTop: '1em', 
                paddingBottom: '1em', paddingLeft: '6px',
                paddingRight: '6px'
            }}
        >

            {activeDomain === tableauPetroleumImportsProps.domain && (
                <Col key="adhoc-1" style={{paddingLeft: "6px", paddingRight: "6px", height: '100%'}}>
                <PetroleumImports key="adhoc=1" metadataObject={{
                    allProps: tableauPetroleumImportsProps,
                    datasetName: "Hawaii Petroleum Imports", 
                    domain: tableauPetroleumImportsProps.domain,
                    filename:"petroleum_imports.csv",
                    schema_filename:"petroleum_imports_schema.csv",
                    description: tableauPetroleumImportsProps.description,
                }}/>
                </Col>
            )}



            {/* !! Preexisting cards pointing to Datawrapper visualizations */}
            {chartMetadata.map((metaObj, idx) => (
                <Col key={idx} style={{paddingLeft: "6px", paddingRight: "6px", height: '100%'}}>
                    <DatasetCard key={idx} metadataObject={metaObj}/>
                </Col>
            ))}



            {/* test of manually created cards pointing to tableau visualizations */}
            {/* <Col key="adhoc-1" style={{paddingLeft: "6px", paddingRight: "6px", height: '100%'}}>
                <StateConsumptionFY23 key="adhoc=1" metadataObject={{
                    datasetName: "State Electricity Consumption by Agency", 
                    chartPackageDate: "FY23",
                    tableauURL: tableauByAgencyURL,
                    tableauModalURL: tableauByAgencyURL,
                    domain:"energy_efficiency/v2",
                    filename:"state_facilities_electricity_usage.csv",
                    description: "",
                }}/>
            </Col>
            <Col key="adhoc-1" style={{paddingLeft: "6px", paddingRight: "6px", height: '100%'}}>
                <StateConsumptionFY23 key="adhoc=1" metadataObject={{
                    datasetName: "State Electricity Consumption by Month", 
                    chartPackageDate: "FY23",
                    tableauURL: tableauByMonthURL,
                    tableauModalURL: tableauByMonthLegendURL,
                    domain:"energy_efficiency/v2",
                    filename:"state_facilities_electricity_usage.csv",
                    description: "",
                }}/>
            </Col> */}


        </Row>
    )
}


export default DatasetCardGrid;